// extracted by mini-css-extract-plugin
export default {"tac":"tac_tac__SxHHb","card":"tac_card__dhukH","txt":"tac_txt__EQ7mP","btn":"tac_btn__GGGc+","hea":"tac_hea__X6ugl","icon":"tac_icon__hOtOl"};